<template>
  <div>
    <jd-form class="mb16" :formData.sync="searchInfo" :form-info="versatileAnswersFormInfo"
      @search="getParticipateRecord" ref="funGameRecordRef">
      <template #skuIds>
        <jd-button type="blue" @click="addGoods()">添加商品(已选{{ currentSelectGoods.length }}个)</jd-button>
      </template>
    </jd-form>
    <div style="margin-bottom: 16px" class="flex-between">
      <div>
        <!-- <jd-button
          type="blueLine"
          :disabled="!dataSource.length"
          @click="addCrowd"
          >按查询结果生成人群</jd-button
        >
        <jd-button @click="isShowStatic = true">答题统计</jd-button> -->
      </div>
      <jd-button type="text" :disabled="!dataSource.length" @click="exportAll"
        >导出</jd-button
      >
    </div>
    <div class="new-table-box">
      <jd-table
        v-loading="loading"
        :tableData="dataSource"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
        row-key="id"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: total,
        }"
        @handlePage="handleCurrentChangeAll"
      >
        <el-table-column prop="mainSkuId" label="本次导购主推商品" min-width="300">
          <template #default="{ row }">
            <div v-if="row.skuId || row.title">
              <div>{{ row.title }}</div>
              <div>商品id:{{ row.skuId ? row.skuId : '-' }}</div>
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>

        <el-table-column prop="userTags" label="商品标签" min-width="300">
          <template #default="{ row }">
          <div>
            <span v-for="(tag,index) in handleUserTags(row.tagsText)" :key="tag">
              <template v-if="tag !== '' && tag.indexOf('https://') !== -1">
                <img :src="tag" alt="" style="width: 30px; height: 30px;">
              </template>
              <span v-else>{{tag}}</span>
              <span v-if="index < handleUserTags(row.tagsText).length - 1">;</span>
            </span>
            <span v-if="handleUserTags(row.tagsText).length == 0">-</span>
          </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="recommendCount"
          label="累计推荐次数"
          min-width="120"
        />
        <el-table-column
          prop="mainRecommendCount"
          label="主推次数"
          min-width="120"
        />
        <el-table-column
          prop="addCartCount"
          label="加购次数"
          min-width="120"
        />
        <el-table-column
          prop="addCartUserCount"
          label="加购人数"
          min-width="120"
        />
        <el-table-column
          prop="addCartRate"
          label="加购率"
          min-width="120"
        />
        <el-table-column
          prop="orderClickCount"
          label="下单点击次数"
          min-width="120"
        />
        <el-table-column
          prop="orderClickUserCount"
          label="下单点击人数"
          min-width="120"
        />
        <el-table-column
          prop="orderClickRateStr"
          label="下单点击率"
          min-width="120"
        />
        <el-table-column
          prop="orderCount"
          label="下单订单笔数"
          min-width="120"
        />
        <el-table-column
          prop="orderUserCount"
          label="下单人数"
          min-width="120"
        />
        <el-table-column
          prop="orderConvertRateStr"
          label="下单转化率"
          min-width="120"
        />
        <el-table-column
          prop="payOrderCount"
          label="付款订单笔数"
          min-width="120"
        />
        <el-table-column
          prop="payUserCount"
          label="付款人数"
          min-width="120"
        />
        <el-table-column
          prop="payConvertRateStr"
          label="付款转化率"
          min-width="120"
        />

        <!-- <el-table-column
          v-for="question in dynamicColumns"
          :key="question"
          :label="question"
          min-width="150"
        >
          <template #default="{ row }">
            <div
              @click="showImage(row.answerVOList, question, $event)"
              v-html="getAnswer(row.answerVOList, question)"
            ></div>
          </template>
        </el-table-column> -->
      </jd-table>
    </div>
    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog.sync="isShowCrowdDialog"
      :activityType="rowData.activityType"
      :source="6"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      :searchForm="crowCondition"
      @close="crowdClose"
    />
    <quesStatistics
      titleText="答题统计"
      :show.sync="isShowStatic"
      :activityId="rowData.id"
    ></quesStatistics>

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>

    <!-- 关联商品弹窗 -->
    <selectGoodsMonitor
      v-if="isShowGoods"
      ref="selectGoFilterOne"
      :isShow="isShowGoods"
      @close="getSelectGoods"
      :selectGoods="currentSelectGoods"
      :isClear="true"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
    ></selectGoodsMonitor>
  </div>
</template>

<script>
import crowdDialog from "../../crowd-Dialog.vue";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import {
  getAnswerGuideRecommendProductPage,
  getAnswerGuideRecommendProductExport,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import quesStatistics from "../_components/questionnaireStatistics.vue";
export default {
  components: {
    crowdDialog,
    quesStatistics,
    selectGoodsMonitor,
  },
  props: {
    inputInfo: {
      type: Array,
      default: () => [],
    },
    rowData: {
      type: Object,
      default: () => {},
    },
    levelMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      hasSelectGoods: [],
      currentSelectGoods: [],
      isShowGoods: false,
      currentImageUrl: "",
      showImageDialog: false,
      isShowStatic: false,
      total: 0,
      formList: {
        size: 10,
        current: 1,
      },
      dataSource: [],
      loading: false,
      searchInfo: {
        tagKeyword:"",
        skuIds:"",
        statTimeBegin:"",
        statTimeEnd:"",
      }, // 搜索参数
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: true, // 是否有默认值
      defaultValueText: "参与记录", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      crowCondition: {},
    };
  },
  computed: {
    versatileAnswersFormInfo: {
      get() {
        return this.inputInfo;
      },
      set(val) {
        this.$emit("update:inputInfo", val);
      },
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 处理用户标签
    handleUserTags(tags){
      if(tags){
        let tagList = tags.split("；");
        return tagList
      }
      return [];
    },
    getSelectGoods(data){
      if (data) {
        this.currentSelectGoods = data;
      }
      this.isShowGoods = false;
    },
    addGoods() {
      this.isShowGoods = true;
    },
    handleCurrentChangeAll(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getList();
    },
    /**
     * 搜索
     * @param params 查询参数
     * @param type 类型 reset 重置  search 搜索
     */
    getParticipateRecord(params,type) {
      this.formList.current = 1;
      this.formList.size = 10;
      if(type){
        this.currentSelectGoods = [];
      }
      // this.searchInfo.memberNick = params.memberNick ? params.memberNick : "";
      // this.searchInfo.pin = params.pin ? params.pin : "";
      // this.searchInfo.sellerLinkId = params.sellerLinkId
      //   ? params.sellerLinkId
      //   : "";
      // this.searchInfo.answerStartTime = params.answerStartTime
      //   ? params.answerStartTime
      //   : "";
      // this.searchInfo.answerEndTime = params.answerEndTime
      //   ? params.answerEndTime
      //   : "";
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const params = {
          ...this.searchInfo,
          ...this.formList,
          activityId: this.rowData.id,
          skuIds: this.currentSelectGoods.map((item) => (item.skuId)),
        };
        this.crowCondition = {
          ...params,
          hdSource: 6,
          activityType: this.rowData.activityType,
        };
        const res = await getAnswerGuideRecommendProductPage(params);
        this.loading = false;
        let { records = [], total = 0 } = res.data;
        this.dataSource = records;
        // 提取所有可能的题目类型
        const allQuestions = new Set();
        records.forEach((item) => {
          if (item.answerVOList && item.answerVOList.length) {
            item.answerVOList.forEach((answer) => {
              allQuestions.add(answer.type);
            });
          }
        });
        this.dynamicColumns = Array.from(allQuestions);
        console.log(this.dynamicColumns,'55454');
        this.total = Number(total);
      } catch (error) {
        this.loading = false;
      } 
    },
    showImage(answerList, question, event) {
      const answer = answerList.find((item) => item.type === question);
      // 检查是否有内容
      if (!answer || !answer.content) {
        return;
      }
      // 找到被点击的元素
      let target = event.target;

      // 如果点击的是放大镜图标，找到对应的图片
      if (target.className === "el-icon-zoom-in") {
        target = target.closest(".image-container").querySelector("img");
      }
      // 确保点击的是图片元素或其容器
      if (target.tagName === "IMG") {
        // 从自定义属性中获取图片URL
        const imageUrl = target.getAttribute("data-url");

        if (imageUrl) {
          this.currentImageUrl = imageUrl;
          this.showImageDialog = true;
        }
      } else if (target.classList.contains("image-overlay")) {
        // 如果点击的是遮罩层，找到对应的图片
        const img = target.parentElement.querySelector("img");
        if (img) {
          const imageUrl = img.getAttribute("data-url");
          if (imageUrl) {
            this.currentImageUrl = imageUrl;
            this.showImageDialog = true;
          }
        }
      }
    },
    // 获取答案
    getAnswer(answerList, question) {
      const answer = answerList.find((item) => item.type === question);
      if (answer) {
        // 如果是图片上传题，返回图片标签
        if (question.includes("图片上传题") && answer.content) {
          // 使用逗号分隔多个图片地址
          const imageUrls = answer.content.split(",").map((url) => url.trim());
          // 生成图片标签
          const imagesHtml = imageUrls
            .map((url, index) => {
              return `
              <div class="image-container" style="display: inline-block; position: relative; margin-right: 10px;">
                <img src="${url}" alt="图片" data-index="${index}" data-url="${url}" style="width: 50px; height: 50px; cursor:pointer;">
                <div class="image-overlay" style="cursor:pointer; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: none; justify-content: center; align-items: center;">
                  <i class="el-icon-zoom-in" style="color: white; font-size: 20px;"></i>
                </div>
              </div>
            `;
            })
            .join("");
          return imagesHtml;
        } else if (question.includes("图片多选题") && answer.content) {
          // 使用逗号分隔多个图片地址
          const imageUrls = answer.content.split(",").map((url) => url.trim());
          // 生成图片标签
          const imagesHtml = imageUrls
            .map((url, index) => {
              return `
              <div class="image-container" style="display: inline-block; position: relative; margin-right: 10px;">
                <img src="${url}" alt="图片" data-index="${index}" data-url="${url}" style="width: 50px; height: 50px; cursor:pointer;">
                <div class="image-overlay" style="cursor:pointer; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: none; justify-content: center; align-items: center;">
                  <i class="el-icon-zoom-in" style="color: white; font-size: 20px;"></i>
                </div>
              </div>
            `;
            })
            .join("");
          return imagesHtml;
        } else if (question.includes("图片选择题") && answer.content) {
          // 如果是图片选择题，返回单个图片标签
          return `
            <div class="image-container" style="display: inline-block; position: relative;">
              <img src="${answer.content}" alt="图片" data-url="${answer.content}" style="width: 50px; height: 50px; cursor:pointer;">
              <div class="image-overlay" style="cursor:pointer; position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); display: none; justify-content: center; align-items: center;">
                <i class="el-icon-zoom-in" style="color: white; font-size: 20px;"></i>
              </div>
            </div>
          `;
        } else if (question.includes("矩阵题") && answer.content) {
          let contentArr = answer.content
            .split(",")
            .map((content) => content.trim());
          const contentHtml = contentArr
            .map((content, index) => {
              return `
              <div style="display: block; position: relative;">
                <div>${content}</div>
              </div>
            `;
            })
            .join("");
          return contentHtml;
        } else {
          // 其他类型返回内容
          return answer.content || "-";
        }
      }
      return "-";
    },
    // 生成人群
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "参与记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    /**
     * 导出
     */
    exportAll() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
    confirmExport(remark = "") {
      let params = {
        ...this.formList,
        ...this.searchInfo,
        activityId: this.rowData.id,
        remark,
      };
      this.formLoading = true;
      getAnswerGuideRecommendProductExport(params).then((res) => {
        this.formLoading = false;
        if (res.code == 1) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
